// extracted by mini-css-extract-plugin
module.exports = {"root":"Heading2_root__kYsRi"};